import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import useTable from "../components/useTable";
import useTableScroll from "../components/useTableScroll.js";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import axios from "axios";

const CatalogoAgente = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "ID", textAlign: "center" },
    { label: "NOMBRES", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idagente.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarAgente = () => {
    let endpoint = `${op.conexion}/api/catalogo/agente`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var age = [];
          for (let i = 0; i < response.data.length; i++) {
            age.push({
              idagente: response.data[i].idagente,
              nombre: response.data[i].nombre,
            });
          }
          setRecords(age);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setItemSelect("");
    setActivate(false);
    setRecords([]);
    setActivo(true);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatAge();
  };

  const seleccionarProveedors = (index) => (event) => {
    var idage = values[0].idage;
    var nombage = values[0].nombage;

    blanquear();
    props.onHideAceptaCatAge(idage, nombage);
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    var idage = recordsAfterPagingAndSorting()[index].idagente;
    var nombage = recordsAfterPagingAndSorting()[index].nombre;

    var datos = [];
    datos.push({
      idage,
      nombage,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarAgente();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Agente</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-2 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control"
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={item.idproveedor}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idagente}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombre}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarProveedors()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoAgente;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoAgente.js